export default __webpack_public_path__ + "locales/pl/Ldap.json?hash=da44e82c90c8bb74aa0d9fcd61395424";